import type {Moment} from 'moment-timezone'
import type {DateOption} from '@freckle/educator-entities/ts/common/helpers/date-options'
import {spanDangerous} from '@freckle/educator-entities/ts/common/models/html-text'
import type {StudentGoalT} from '@freckle/educator-entities/ts/common/models/student-goal'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import {Alert} from '@freckle/educator-materials/ts/components/alert'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {MenuBar} from '@freckle/classroom/ts/common/components/menu-bar'
import {PageWrapper} from '@freckle/classroom/ts/common/components/page-wrapper'
import {StudentGoalsType} from '@freckle/classroom/ts/common/logic/session-history'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'
import {CourseSelectorHandler} from './../../common/components/course-selector/course-selector-handler'
import {SessionHistoryMenu} from './../../common/components/session-history-menu'
import {StudentGoalsTable} from './student-goals-table'

type Props = {
  goals: Array<StudentGoalT>
  students: Array<StudentAttrs>
  isPremium: boolean
  selectedDateOption: DateOption
  from: Moment
  to: Moment
}

export function StudentGoalsContainer(props: Props) {
  const {t} = useSafeTranslation()
  const {goals, students, isPremium, selectedDateOption, from, to} = props
  const breadcrumbsConfig = {
    currentItemName: spanDangerous(t('STUDENT_GOALS_PAGE_TITLE')),
    path: [
      {
        url: Routes.reportsOverview('math'),
        name: t('BREADCRUMB_REPORT_OVERVIEW_NAME'),
      },
    ],
  }

  return (
    <PageWrapper
      breadcrumbsConfig={breadcrumbsConfig}
      pageHeaderText={t('STUDENT_GOALS_PAGE_TITLE')}
    >
      <>
        <Alert type="warning">
          <SafeTrans i18nKey="STUDENT_GOALS_PAGE_WARNING" components={{bold: <strong />}} />
        </Alert>
        <MenuBar>
          <>
            <CourseSelectorHandler withLabel />
            <SessionHistoryMenu
              sessionType={StudentGoalsType}
              isPremium={isPremium}
              dateOption={selectedDateOption}
              from={from}
              to={to}
            />
          </>
        </MenuBar>
        <StudentGoalsTable students={students} goals={goals} />
      </>
    </PageWrapper>
  )
}
